function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyAdded({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Sent to bank",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 71759",
    d: "M22 22H0V0h22z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 71760",
    d: "M6.527 5.3 4.7 7.126l-.481-.481L6.867 4l2.645 2.645-.481.481L7.207 5.3v4.14h-.68z",
    transform: "rotate(90 6.794 10.927)",
    style: {
      fill: "#409828"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 34",
    d: "M8.5 0 17 8.5 8.5 17 0 8.5z",
    transform: "translate(2.391 2.266)",
    style: {
      stroke: "#409828",
      fill: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyAdded);
export default __webpack_public_path__ + "static/media/money-added.5dd76f04ed30909734cb820eedab1896.svg";
export { ForwardRef as ReactComponent };